module.exports = __webpack_public_path__ + "media/xp-gain.53091138.mp3";